import { IOffer } from "@nju/data-access-portal-offers";
import { Separator, Text } from "@nju/ui";
import { IButtonType, IFilteredOffer, IPackageType } from "../types";
import { Package } from "./Package";

interface IPromoPackagesProps {
  selectedVoicePackage: IOffer | undefined;
  packageType: IPackageType;
  offers: IFilteredOffer;
  onSelectVoicePackage: (type: IButtonType, packageType: IPackageType) => void;
  onSelectDataPackage: (type: IButtonType, packageType: IPackageType) => void;
  selectedDataPackage: IOffer | undefined;
}

export function Packages({
  selectedVoicePackage,
  packageType,
  offers,
  onSelectVoicePackage,
  selectedDataPackage,
  onSelectDataPackage,
}: IPromoPackagesProps) {
  return (
    <>
      {selectedVoicePackage && offers.voicePackage.length > 0 && (
        <>
          <Text
            size={{
              "@fromTablet": "l",
              "@onlyMobile": "s",
            }}
          >
            Wybierz, ile min./SMS/MMS potrzebujesz.
          </Text>
          <Separator size="xxs" tone="invisible" />
          <Package
            isDataPackage={
              selectedVoicePackage.productSpecificationId === "DATA_PACKAGE"
            }
            isFirst={offers.voicePackage.indexOf(selectedVoicePackage) === 0}
            isLast={
              offers.voicePackage.indexOf(selectedVoicePackage) ===
              offers.voicePackage.length - 1
            }
            isVoicePackage={
              selectedVoicePackage.productSpecificationId === "VOICE_PACKAGE"
            }
            offers={offers.voicePackage}
            onSelect={onSelectVoicePackage}
            packageType={packageType}
            selectedOffer={selectedVoicePackage}
            testId="voice-package"
          />
          <Separator size="s" tone="invisible" />
        </>
      )}
      {selectedDataPackage && offers.dataPackage.length > 0 && (
        <>
          <Text
            size={{
              "@fromTablet": "l",
              "@onlyMobile": "s",
            }}
          >
            Wybierz, ile GB potrzebujesz.
          </Text>
          <Separator size="xxs" tone="invisible" />
          <Package
            isDataPackage={
              selectedDataPackage.productSpecificationId === "DATA_PACKAGE"
            }
            isFirst={offers.dataPackage.indexOf(selectedDataPackage) === 0}
            isLast={
              offers.dataPackage.indexOf(selectedDataPackage) ===
              offers.dataPackage.length - 1
            }
            isVoicePackage={
              selectedDataPackage.productSpecificationId === "VOICE_PACKAGE"
            }
            offers={offers.dataPackage}
            onSelect={onSelectDataPackage}
            packageType={packageType}
            selectedOffer={selectedDataPackage}
            testId="data-package"
          />
        </>
      )}
    </>
  );
}
